<script setup>
import SkillItem from "@/components/skills/SkillItem.vue";

const skills = [
  {
    icon: "fas fa-laptop",
    title: "Front-End",
    description:
        "Através do uso de tecnologias de ponta como VueJS, React, HTML e CSS, eu sou capaz de criar interfaces de usuário dinâmicas e intuitivas que tornam a navegação em um site ou aplicativo uma experiência fluida e agradável para o usuário final.",
  },
  {
    icon: "fas fa-server",
    title: "Back-End",
    description:
        "Com o uso do NodeJS, eu sou capaz de criar soluções backend robustas e escaláveis que oferecem alta performance e segurança. Meu foco é desenvolver sistemas eficientes e confiáveis que atendam às necessidades do cliente de forma eficaz.",
  },
  {
    icon: "fas fa-mobile-alt",
    title: "Mobile",
    description:
        "Com habilidades em desenvolvimento mobile e expertise em criar aplicações responsivas, eu me dedico a entregar soluções incríveis que proporcionam uma experiência de usuário perfeita, independentemente do dispositivo utilizado.",
  },
];
</script>

<template>
  <v-col cols="12" class="padd" id="portifolio">
    <div class="first" id="project">
      <v-row>
        <v-col cols="12" sm="4" v-for="skill in skills" :key="skill">
          <SkillItem
              :icon="skill.icon"
              :title="skill.title"
              :description="skill.description"
          />
        </v-col>

      </v-row>
    </div>
  </v-col>
</template>

<style scoped>
.child {
  display: inline-block;
  padding: 2rem 1rem;
  vertical-align: middle;
  text-align: center;
  margin-right: 8px;
}
</style>
